import { FormControl, FormHelperText, makeStyles } from "@material-ui/core";
import { Field, useFormikContext } from "formik";
import { CheckboxWithLabel } from "formik-material-ui";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "block",
  },
  errorText: {
    color: theme.palette.error.main,
  },
}));

export default function FormikCheckboxField({ idPrefix = "", ...props }) {
  const classes = useStyles();
  const formik = useFormikContext();

  return (
    <FormControl
      name={props.name}
      className={classes.root}
      error={formik.errors[props.name] && formik.touched[props.name]}
    >
      <Field
        component={CheckboxWithLabel}
        id={idPrefix ? idPrefix + "-" + props.name : props.name}
        type="checkbox"
        Label={{ label: props.label }}
        {...props}
      />
      <div>
        {formik.errors[props.name] && formik.touched[props.name] && (
          <FormHelperText
            className={classes.errorText}
            data-cy={(idPrefix ? idPrefix + "-" + props.name : props.name) + "-helper-text"}
            id={(idPrefix ? idPrefix + "-" + props.name : props.name) + "-helper-text"}
          >
            {formik.errors[props.name]}
          </FormHelperText>
        )}
      </div>
    </FormControl>
  );
}
